import camelCaseKeys from 'camelcase-keys'

export const Campaign = {
  maxDeliveryLocationGroups: 99,
}

export class CampaignModel {
  constructor(item) {
    const {
      buyingCurrency,
      campaign,
      campaignBudget,
      campaignBudgetProgress,
      campaignDailyProgress,
      campaignId,
      clicks,
      cpBillingPeriodId,
      cpc,
      cpm,
      ctr,
      imps,
      insertionOrder,
      insertionOrderId,
      revenueBuyingCurrency,
    } = camelCaseKeys(item)

    this.buyingCurrency = buyingCurrency || undefined
    this.campaign = campaign || undefined
    this.campaignBudget = campaignBudget || undefined
    this.campaignBudgetProgress = campaignBudgetProgress || undefined
    this.campaignDailyProgress = campaignDailyProgress || undefined
    this.campaignId = Number(campaignId) || undefined
    this.clicks = Number(clicks) || undefined
    this.cpBillingPeriodId = Number(cpBillingPeriodId) || undefined
    this.cpc = Number(cpc) || undefined
    this.cpm = Number(cpm) || undefined
    this.ctr = Number(ctr) || undefined
    this.imps = Number(imps) || undefined
    this.insertionOrder = insertionOrder || undefined
    this.insertionOrderId = Number(insertionOrderId) || undefined
    this.revenueBuyingCurrency = Number(revenueBuyingCurrency) || undefined
  }
}

export class CampaignItemModel {
  constructor(item) {
    const {
      buyingCurrency,
      campaign,
      campaignId,
      clicks,
      cpc,
      cpm,
      ctr,
      imps,
      insertionOrder,
      insertionOrderId,
      reportDate,
      revenueBuyingCurrency,
    } = camelCaseKeys(item)

    this.buyingCurrency = buyingCurrency || undefined
    this.campaign = campaign || undefined
    this.campaignId = Number(campaignId) || undefined
    this.clicks = Number(clicks) || undefined
    this.cpc = Number(cpc) || undefined
    this.cpm = Number(cpm) || undefined
    this.ctr = Number(ctr) || undefined
    this.imps = Number(imps) || undefined
    this.insertionOrder = insertionOrder || undefined
    this.insertionOrderId = Number(insertionOrderId) || undefined
    this.reportDate = reportDate || undefined
    this.revenueBuyingCurrency = Number(revenueBuyingCurrency) || undefined
  }
}
